<template>
  <div class="anina">
    <h1>Steierdorf, Anina</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/cara_1kl.jpg" width="125" height="110" border="0" alt="Carasova, ein kroatisches Dorf an der Straße von Reşiţa nach Anina"
        @click="callImageClick('Carasova, ein kroatisches Dorf an der Straße von Reşiţa nach Anina', 'cara_1.jpg', $event)">
						<br>Carasova, ein kroatisches Dorf an der Straße von Reşiţa nach Anina
      </div>
      <div class="foto">
        <img src="../assets/fotos/anin_1kl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: evangelische Kirche"
        @click="callImageClick('Anina / Steierdorf: evangelische Kirche', 'anin_1.jpg', $event)">
        <br>Anina / Steierdorf: evangelische Kirche
			</div>
      <div class="foto">		
				<img src="../assets/fotos/anin_2kl.jpg" width="125" height="110" border="0" alt="Anina / Steierdorf: evangelische Kirche"
        @click="callImageClick('Anina / Steierdorf: evangelische Kirche', 'anin_2.jpg', $event)">
        <br>Anina / Steierdorf: evangelische Kirche
			</div>
      <div class="foto">		
				<img src="../assets/fotos/anin_3kl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: evangelische Kirche"
        @click="callImageClick('Anina / Steierdorf: evangelische Kirche', 'anin_3.jpg', $event)">
        <br>Anina / Steierdorf: evangelische Kirche
			</div>
      <div class="foto">		
				<img src="../assets/fotos/anin_4kl.jpg" width="125" height="110" border="0" alt="Anina / Steierdorf: Sommerfrische"
        @click="callImageClick('Anina / Steierdorf: Sommerfrische', 'anin_4.jpg', $event)">
        <br>Anina / Steierdorf: Sommerfrische
			</div>
      <div class="foto">	
				<img src="../assets/fotos/anin_5kl.jpg" width="125" height="110" border="0" alt="Anina / Steierdorf: römisch-katholische Kirche"
        @click="callImageClick('Anina / Steierdorf: römisch-katholische Kirche', 'anin_5.jpg', $event)">
        <br>Anina / Steierdorf: römisch-katholische Kirche
			</div>
      <div class="foto">	
			  <img src="../assets/fotos/anin_6kl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: Stadtbus"
        @click="callImageClick('Anina / Steierdorf: Stadtbus', 'anin_6.jpg', $event)">
        <br>Anina / Steierdorf: Stadtbus
			</div>
      <div class="foto">	
				<img src="../assets/fotos/anin_8kl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: Sigismund"
        @click="callImageClick('Anina / Steierdorf: Sigismund', 'anin_8.jpg', $event)">
        <br>Anina / Steierdorf: Sigismund
			</div>
      <div class="foto">	
				<img src="../assets/fotos/anin_9kl.jpg" width="125" height="110" border="0" alt="Anina / Steierdorf: Ölschieferwerk"
        @click="callImageClick('Anina / Steierdorf: Ölschieferwerk', 'anin_9.jpg', $event)">
        <br>Anina / Steierdorf: Ölschieferwerk
			</div>
      <div class="foto">	
			  <img src="../assets/fotos/anin_bkl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: Gänse"
        @click="callImageClick('Anina / Steierdorf: Gänse', 'anin_b.jpg', $event)">
        <br>Anina / Steierdorf: Gänse
			</div>
      <div class="foto">	
				<img src="../assets/fotos/anin_ckl.jpg" width="125" border="0" height="110" alt="Anina / Steierdorf: Blick auf Anina"
        @click="callImageClick('Anina / Steierdorf: Blick auf Anina', 'anin_c.jpg', $event)">
        <br>Anina / Steierdorf: Blick auf Anina
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>